import { Link, useNavigate } from "react-router-dom";
import { ChevronRight, ExternalLink, LogOut } from "lucide-react";
import { Card, PageHeader } from "@/components/admin/common";
import { EXTRA, logout } from "@/components/admin/AdminLayout";

export default function More() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg" data-testid="more-page">
      <PageHeader title="More" />
      <Card className="divide-y divide-border">
        {EXTRA.map((l) => (
          <Link key={l.to} to={l.to} className="flex items-center gap-3 px-4 h-16 font-bold" data-testid={`more-${l.label.toLowerCase().replace(/ /g, "-")}`}>
            <l.icon className="w-5 h-5 text-ocean" />{l.label}<ChevronRight className="w-4 h-4 ml-auto text-slate-400" />
          </Link>
        ))}
        <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 h-16 font-bold" data-testid="more-view-site"><ExternalLink className="w-5 h-5 text-ocean" />View website</a>
        <button onClick={() => logout(navigate)} className="w-full flex items-center gap-3 px-4 h-16 font-bold text-rose-600" data-testid="more-logout"><LogOut className="w-5 h-5" />Log out</button>
      </Card>
    </div>
  );
}
